import React from 'react';
import { PerformanceSummary } from './types';

interface DifficultyAnalysisProps {
  performanceSummary: Pick<PerformanceSummary, 'easy_level_accuracy' | 'medium_level_accuracy' | 'hard_level_accuracy'>;
}

const DifficultyAnalysis: React.FC<DifficultyAnalysisProps> = ({ performanceSummary }) => {
  return (
    <div className="row mb-4">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mb-0">
              <i className="fas fa-layer-group me-2"></i>
              Difficulty Level Performance
            </h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-4">
                <div className="text-center p-3 border rounded">
                  <h6 className="text-success">Easy Level</h6>
                  <div className="progress mb-2">
                    <div 
                      className="progress-bar bg-success" 
                      style={{ width: `${performanceSummary.easy_level_accuracy}%` }}
                    ></div>
                  </div>
                  <span className="badge bg-success">{performanceSummary.easy_level_accuracy}%</span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="text-center p-3 border rounded">
                  <h6 className="text-warning">Medium Level</h6>
                  <div className="progress mb-2">
                    <div 
                      className="progress-bar bg-warning" 
                      style={{ width: `${performanceSummary.medium_level_accuracy}%` }}
                    ></div>
                  </div>
                  <span className="badge bg-warning text-dark">{performanceSummary.medium_level_accuracy}%</span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="text-center p-3 border rounded">
                  <h6 className="text-danger">Hard Level</h6>
                  <div className="progress mb-2">
                    <div 
                      className="progress-bar bg-danger" 
                      style={{ width: `${performanceSummary.hard_level_accuracy}%` }}
                    ></div>
                  </div>
                  <span className="badge bg-danger">{performanceSummary.hard_level_accuracy}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DifficultyAnalysis;